<template>
<div id="scrollTemp">
  <div class="d-flex bg-white rounded mx-auto overflow-auto mb-4 mt-2"  id="scrollTempDiv" style="width:96%; border:1px solid #dee2e6 !important;position: sticky;top: 49px;z-index: 997;">
    <button class="px-3 my-font py-2 text-dark  group-title" style="min-width: fit-content;cursor: pointer;border: none;background-color: transparent;" v-for="item,index in list" :key="index" :href="'#group'+item.id" :id="'group'+item.id+'title'" @click="goOnPage($event,item.id)">
    <img :src="'https://radap.ir/'+item.src" width="50" v-if="item.src"/>
      {{ item.name }}
    </button>
  </div>
    <section v-for="pitem,index in list" :key="pitem.id" :data-group-id="pitem.id" class="sc-o27kl3-0 gsZmuC product-slider-section group-item" :id="'group'+pitem.id" >
      <div class="d-flex justify-content-between">
        <h3 class="mb-3 h3 mr-2 group-name" style="font-size:1.2em;width: 100%;overflow: hidden;white-space: pre-line;">{{pitem.name}}</h3>
      </div>
        <div>
          <div class="sc-d8w7bo-1 jpdybm">
            <div direction="row" class="sc-1r3hge1-0 heMFVq ">
              <product-border :list="pitem.item" />
            </div>
          </div>
        </div>
  </section>
</div>
</template>
<script setup>
import { ref,watch,computed,defineProps,onUnmounted} from 'vue'
import { useRoute } from 'vue-router';
import ProductBorder from '../../item/ProductBorder.vue';
let props = defineProps(['storeId']);
let list = ref();
const route = useRoute()
const group = computed(() => route.params.item || 1);
let classFlage = ref(false)
watch(group, async () => {
  await getItems();
}, { immediate: true });
async function getItems(){
  let response = await fetch('https://radap.ir/Backend/api/section/pages/group/list/get_new.php?id='+group.value+'&shop_id='+props.storeId)
  let data = await response.json();
    document.querySelector('#productModalCloseBTN').click()
    list.value = data;
    window.scrollTo({
      top: 0,
      behavior: "auto"
    });
}
function goOnPage(e,id){
  if(classFlage.value != false){
    document.getElementsByClassName('active')[0].classList.remove('active')
  }
    classFlage.value = true;
    e.target.classList.add('active')
    var element = document.getElementById('group'+id);
    var headerOffset = 115;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
         top: offsetPosition,
         behavior: "auto"
    });
}
// تعریف کردن ایونت اسکرول برای انتخاب گروه های تیتر بصورت پیش فرض
document.addEventListener('scroll',getActiveGroup)
onUnmounted(() => {
  // حذف ایونت اسکرول بعداز بستن صفحه
  document.removeEventListener('scroll', getActiveGroup)
})

function getActiveGroup(){
  let pageScroll = window.scrollY
  let elemPos;
  let id;
  document.querySelectorAll('.group-item').forEach((elem,index) =>{
    elemPos = Math.round(elem.getBoundingClientRect().top) + pageScroll - 120
    id = elem.id
    if(pageScroll > elemPos ){
      document.querySelectorAll('.active').forEach(aelem=>{
        aelem.classList.remove('active')
      })
      // console.log(id+'title');
      if(document.getElementById(id+'title')){
        document.getElementById(id+'title').classList.add('active')
        goOnPage2()
      }
    }
  })
}
function goOnPage2() {
    var element = document.querySelector('.active');
    var offsetPosition = element.offsetLeft - 100;
    document.getElementById('scrollTempDiv').scrollTo({
         left: offsetPosition,
         behavior: "auto"
    });
}
</script>

<style scoped>
.hDcCcC {
    /* margin-left: 13px;
    margin-right: 13px; */
    max-width: 13.5rem;
    margin-bottom: 13px;
    display: inline-block;
}
.heMFVq {
    /* display: inline-block; */
    flex-direction: row;
    /* padding-right: 1.2rem; */
    overflow: auto auto;
    padding-bottom: 0.5rem;
}
.my-opacity{
    opacity : .5 !important
}
.my-font{
  font-size: 16px;
  font-weight: 700;
}
.my-padding{
  padding: .75em !important;
}
.active{
  color: red !important;
}

</style>